(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/grassroots-shared/assets/javascripts/views/receiver-generic-item.js') >= 0) return;  svs.modules.push('/modules/grassroots-shared/assets/javascripts/views/receiver-generic-item.js');

(function(Backbone, _, svs) {
  'use strict';

  let initScope = null;
  svs.grassroots.views.ReceiverGenericItem = Marionette.View.extend({
    template: function(data) {
      return Object.prototype.hasOwnProperty.call(data, initScope.type) ?
        svs.grassroots.templates.receiver_generic_item(data) :
        '';
    },
    templateContext: {
      isCorporateSite: svs.grassroots.data.config.isCorporateSite
    },

    events: {
      'click .js-add-support-btn': 'addSupport',
      'click .js-remove-support-btn': 'removeSupport',
      'click .expandable-box-header-yearlystatistics': 'toggleAllYearlystatistics'
    },
    modelEvents: {
      change: 'render'
    },

    tagName: 'div',

    initialize: function(options) {
      initScope = this;
      initScope.type = options.type;
    },
    addSupport: function() {
      var longnameUrl;
      if (svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER)) {
        svs.ui.loader.show();
        this.model.collection.addSupport(
          this.model.get('id'),
          this.model.get('longname'),
          this.el
        );
      } else {
        longnameUrl = this.model.get('longname');
        svs.grassroots.router.navigate(
          this.getOption('path') +
          '?active=' +
          this.getOption('tabName') +
          '&add=' +
          this.model.get('id') +
          '&name=' +
          longnameUrl,
          { silent: true }
        );
        svs.components.customer_login.login();
      }
      return false;
    },
    removeSupport: function() {
      svs.ui.loader.show();
      this.model.collection.removeSupport(
        this.model.get('id'),
        this.model.get('longname')
      );
      return false;
    },
    toggleAllYearlystatistics: function(e) {
      if (e.currentTarget.innerText === 'Visa fler') {
        e.currentTarget.innerText = 'Visa färre';
      } else {
        e.currentTarget.innerText = 'Visa fler';
      }
      return true;
    }
  });
})(Backbone, _, svs);


 })(window);